import { defineMessages } from 'react-intl';

export default defineMessages({
    withdraw: {
        id: '_.rbl_drawdown.confirm.withdraw',
        defaultMessage: 'You are requesting to withdraw'
    },
    drawdownFee: {
        id: '_.rbl_drawdown.confirm.fee',
        defaultMessage:
            'On top of that, your loan has a fixed fee of {feeAmount}. We’ll add this to your total repayment'
    },
    repaymentAmount: {
        id: '_.rbl_drawdown.confirm.repayment_amount',
        defaultMessage: "Overall, you'll repay"
    },
    revenueSweep: {
        id: '_.rbl_drawdown.confirm.revenue_sweep',
        defaultMessage:
            'You’ll repay this with {sweepPercentage} your of revenue each month.'
    },
    repaymentDates: {
        id: '_.rbl_drawdown.confirm.repayment_dates',
        defaultMessage:
            "We'll take your first payment on {firstRepaymentDate}, then the {repaymentDayOfMonth} of each month."
    }
});
